const words = {
    month: ['Месяц', 'Ay', 'Month'],
    branches: ['По филиалам', 'Filiallar üzrə', 'By branch'],
    branchTotal: ['Итого по показанным счетам', 'Göstərilən hesablar üzrə cəmi', 'Shown accounts total'],
    byAccount: ['По счетам', 'Hesablar üzrə', 'By account'],
    flat: ['Все счета', 'Bütün hesablar', 'All accounts'],
    working: ['На рабочих счетах', 'İş hesablarında', 'On working accounts'],
    custody: ['Деньги на руках', 'Əldə olan pul', 'Money in custody'],
    opening: ['На начало', 'Ayın əvvəli', 'Opening'],
    received: ['Приход', 'Mədaxil', 'Received'],
    paid: ['Расход', 'Məxaric', 'Paid'],
    closing: ['Остаток', 'Qalıq', 'Closing'],
    otherChanges: ['Прочие изменения', 'Digər dəyişikliklər', 'Other changes'],
    eventBasis: ['По датам событий · начальный остаток не входит в приход', 'Hadisə tarixlərinə görə · ilkin qalıq mədaxilə daxil deyil', 'By event date · opening balance excluded from receipts'],
    registrationBasis: ['По датам регистрации', 'Qeydiyyat tarixlərinə görə', 'By registration date'],
    openingAdded: ['Ввод остатка', 'İlkin qalığın daxil edilməsi', 'Opening entered'],
    correction: ['Корректировки', 'Düzəlişlər', 'Corrections'],
    reset: ['Обнуление', 'Sıfırlama', 'Reset'],
    deleted: ['Отмена записей', 'Qeydlərin ləğvi', 'Cancelled entries'],
    transferIn: [
        'В том числе переводы: приход',
        'O cümlədən köçürmələr: mədaxil',
        'Including transfers in',
    ],
    transferOut: [
        'В том числе переводы: расход',
        'O cümlədən köçürmələr: məxaric',
        'Including transfers out',
    ],
    partial: ['Часть данных', 'Məlumatların bir hissəsi', 'Partial data'],
    unknown: ['Нет доступа', 'Giriş yoxdur', 'No access'],
    archiveRequired: [
        'История неполная: нужен доступ к архиву',
        'Tarixçə tam deyil: arxivə giriş tələb olunur',
        'History incomplete: archive access required',
    ],
    draft: ['Начало не подтверждено', 'İlkin qalıq təsdiqlənməyib', 'Opening not confirmed'],
    archived: ['Архивный счёт', 'Arxiv hesabı', 'Archived account'],
    operations: ['Операции', 'Əməliyyatlar', 'Operations'],
    actions: ['Действия со счётом', 'Hesab əməliyyatları', 'Account actions'],
    account: ['Счёт', 'Hesab', 'Account'],
    branch: ['Филиал', 'Filial', 'Branch'],
    details: ['Подробности', 'Ətraflı', 'Details'],
    currency: ['Валюта', 'Valyuta', 'Currency'],
    empty: ['Нет счетов за этот месяц', 'Bu ay üçün hesab yoxdur', 'No accounts for this month'],
    scope: [
        'По доступным счетам · обороты включают переводы',
        'Əlçatan hesablar üzrə · dövriyyəyə köçürmələr daxildir',
        'Accessible accounts · turnover includes transfers',
    ],
    current: ['По состоянию на', 'Məlumatların vaxtı', 'As of'],
    historical: ['На конец месяца', 'Ayın sonuna', 'At month end'],
    movement: ['Движение за месяц', 'Ayın dövriyyəsi', 'Monthly movement'],
};
export const accountMonthText = (locale, key) => words[key][locale === 'az' ? 1 : locale === 'en' ? 2 : 0];
export function cashMonthBounds(month) {
    const [year, m] = month.split('-').map(Number);
    return { from: month + '-01', to: month + '-' + new Date(Date.UTC(year, m, 0)).getUTCDate() };
}
export function cashMonthTotals(rows) {
    const keys = [
        'openingMinor',
        'receivedMinor',
        'paidMinor',
        'closingMinor',
        'openingAddedMinor',
        'correctionMinor',
        'resetMinor',
        'deletedMinor',
        'transferInMinor',
        'transferOutMinor',
    ];
    const known = rows.filter(r => r.coverage === 'COMPLETE');
    const result = {
        accountId: 'total',
        currency: rows[0]?.currency || '',
        coverage: known.length === rows.length ? 'COMPLETE' : 'NO_ACCESS',
    };
    if (known.length)
        for (const key of keys)
            result[key] = known.reduce((sum, row) => sum + BigInt(row[key] || '0'), 0n).toString();
    return result;
}
